import supplierList from './supplierList.vue'
import supplierEdit from './supplierEdit.vue'



let a = Object.assign( { supplierList, supplierEdit})
export default a